var _defs, _rect, _circle, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdeaPanel2Me(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 227 457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-5{fill:none;}.cls-2,.cls-4{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5{stroke:#000;}.cls-2,.cls-3{stroke-miterlimit:10;}.cls-4,.cls-5{stroke-linecap:round;stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 227,
    height: 457
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 55.81,
    cy: 183.79,
    r: 20.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.93,
    cy: 188.98,
    rx: 1.72,
    ry: 2.29
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.31,
    cy: 188,
    rx: 1.72,
    ry: 2.29
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.12,185.23c-2.35-.16-5,.85-5.85,2.92a4.5,4.5,0,0,0,1.87,5.32,6.86,6.86,0,0,0,6.12.42c2.12-.84,3.85-5.58,6.12-5.92,3.67-.56,3.22,6.12,10.85,4.3,2.37-.57,3.11-3.85,2-5.88A5.77,5.77,0,0,0,70.93,184c-1.87.45-4.86,2.33-6.62,2.63S58.48,185.4,56.12,185.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.21,181.89a7.54,7.54,0,0,0-10.08-7.43c-3.9,1.39-4.62,4.78-8.88,5.45-3.18.5-7.28-3.72-10.38-4.58-3.27-.9-6.74,1.35-8.38,4.32s-2.12,6.73-2.32,10.12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.63,187.08l-9.36-1.62a8.81,8.81,0,0,0-3.61-.12c-1.16.29-2.11,1.27-1.66,2.13"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.88,209c-6.89,2.6-10.79,13.73-12,17.48-6.1,18.41-7.75,33.9-5,52,.72,4.68,2.51,8.41,4,12.9s4.91,8.59,9.5,9.73c11.63-9.4,23.45-27.24,38.08-24.15a50.1,50.1,0,0,0-10.62-20.18c-6.64-8-1.78-20.75-.17-31,.54-3.41,1.19-6.15-.35-8.75-1.76-3-7.29-2-10.84-3.38C47.23,212.39,44,206.65,37.88,209Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M92.44,378a28.93,28.93,0,0,0,18.46-2.17c0-19.64,1.81-38.94,1.33-58.73-.16-6.6-.06-13.93-3.1-19.79C105.86,291,99.27,287,92.72,284.22s-19.48-8.82-28.92-7a29.21,29.21,0,0,0-11.1,5.43,94.45,94.45,0,0,0-16.78,17.81,41.1,41.1,0,0,0,34.74-5.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.32,375.9c1.93,1.14,4.3,1.06,6.53,1.27s4.7.94,5.72,2.93c1.12,2.16-.09,5-2.1,6.36s-4.55,1.69-7,1.78-4.94,0-7.25.82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.82,374.9c-.27,1.87-1.06,5.46-1.33,7.33,9.62,4.56,19.62,9.22,30.27,9.37a10.3,10.3,0,0,0,5.19-1,4.29,4.29,0,0,0,2.33-4.41c-.41-1.81-2.22-2.89-3.88-3.7a88.77,88.77,0,0,0-12-4.81"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.88,300.76c6.13,3.72,13.54,4.39,20.51,6.06s14.31,5,17.15,11.61c1.7,3.95,1.48,8.42,1.24,12.7Q72.54,353,71.28,374.9v0a72,72,0,0,0,21.11,2.91l.32-64.48c0-4.67,0-9.53-2-13.75C88.59,295.19,84.47,292,80,290s-9.35-2.85-14.17-3.72"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.07,227.55c0-15.24.18-33.64-.6-48.07-.16-2.9,2.32-5.35,5.64-5.62,22-1.78,41.72-3,63.3-4.75,3.07-.25,5.78,1.84,5.86,4.52l1.43,44.91c.1,3.1-2.41,5.76-5.92,6.29-21.56,3.23-43,6.33-63.33,7.81C120,232.89,117.07,230.52,117.07,227.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M128.7,258.64c-11.32,4.18-22.62,8.26-34.67,11.06a5.78,5.78,0,0,1-3.7-1.06,35.72,35.72,0,0,0-7.93-3.87,1.71,1.71,0,0,1,.11-3.29c11.22-4,22.21-7.44,32.9-10.62a8.65,8.65,0,0,1,6,.35,71.83,71.83,0,0,1,7.79,4A1.86,1.86,0,0,1,128.7,258.64Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.77,219.21c-.86,6.52-.24,11.68,2.6,16.76s7.54,8.91,12.68,11.64,10.74,4.45,16.3,6.16l21.92,6.73a13.56,13.56,0,0,0,4.56.83,4,4,0,0,0,3-7,11.29,11.29,0,0,0-4.38-2.75c-6.1-2.52-12.61-3.85-19-5.58s-12.75-3.91-18-7.86-9.39-9.93-9.7-16.52"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.14,217c7.16,8.17,12,14.25,20.08,18.47s18.39,8.22,26.94,11.31a10.72,10.72,0,0,1,3.4,1.73,4,4,0,0,1,1.54,3.35c-.2,1.66-1.75,2.85-3.32,3.42-3.38,1.23-7.19.53-10.5-.88s-7.14-2.64-10.52-3.87c-7.74-2.83-22.54-12.32-28.89-17.86"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.8,232.72A15.77,15.77,0,0,1,45.16,228"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.09,233.08a13.11,13.11,0,0,1,7.91-8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaPanel2Me);
export default __webpack_public_path__ + "static/media/Idea_Panel_2_Me.fa26d8de2183e1568e7f193066b15eef.svg";
export { ForwardRef as ReactComponent };